// Third Party Libraries Imports
import toast from "react-hot-toast";
import { AxiosResponse } from "axios";
import { useDispatch } from "react-redux";

// Local Imports
import instance from "../../store/axios";
import { LOADING } from "../../store/actions";
import { useNavigate } from "react-router-dom";

class NotificationService {
  private dispatch = useDispatch();
  private navigate = useNavigate();

  public async addNotification(values): Promise<void> {
    this.dispatch({ type: LOADING, payload: true });
    if (values?.categories === "all" || !values?.categories) {
      values.isToAll = true;
      values.users= []
    } else {
      values.isToAll = false;
    }

    try {
      await instance.post(`/${process.env.REACT_APP_ENDPOINT_VERSION}/notification/send-push-notification`, values);
      toast.success("Notification sent successfully");
      this.navigate("/cards");
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem("star_prev_url", `/cards`);
    }
    this.dispatch({ type: LOADING, payload: false });
  }

  public async addNotificationUsingAccountCodes(values): Promise<void> {
    this.dispatch({ type: LOADING, payload: true });

    try {
      await instance.post(`/${process.env.REACT_APP_ENDPOINT_VERSION}/notification/send-push-notification-to-accounts`, values);
      toast.success("Notification sent successfully");
      this.navigate("/cards");
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem("star_prev_url", `/cards`);
    }
    this.dispatch({ type: LOADING, payload: false });
  }
}

export default NotificationService;
